import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = { class: "flex align-items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Danh sách thiết bị đã nhận ", -1)
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thống kê: ", -1)
const _hoisted_9 = {
  class: "p-field p-col p-col-12 p-md-6 p-lg-2",
  style: {"margin-left":"5px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Xuất biên bản:", -1)
const _hoisted_11 = {
  class: "p-field p-col p-col-12 p-md-6 p-lg-2",
  style: {"margin-left":"5px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Tải biên bản", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_14 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_15 = {
  class: "p-input-icon-left",
  style: {"width":"22em"}
}
const _hoisted_16 = {
  class: "vertical-align-middle ml-2 font-bold line-height-3",
  style: {"font-weight":"bold"}
}
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_18 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_21 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng nhận:", -1)
const _hoisted_23 = { class: "list_button" }
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_25 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Bên bàn giao 1:", -1)
const _hoisted_28 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Chức vụ bàn giao 1:", -1)
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Bên bàn giao 2:", -1)
const _hoisted_32 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Chức vụ bàn giao 2:", -1)
const _hoisted_34 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Bên nhận 1:", -1)
const _hoisted_36 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Chức vụ nhận 1:", -1)
const _hoisted_38 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Bên nhận 2:", -1)
const _hoisted_40 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Chức vụ nhận 2:", -1)
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Ghi chú:", -1)
const _hoisted_44 = { class: "list_button" }
const _hoisted_45 = { class: "flex align-items-center gap-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Danh sách thiết bị chờ tiếp nhận ", -1)
const _hoisted_47 = { class: "p-fluid" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_49 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thống kê: ", -1)
const _hoisted_51 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_52 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_53 = {
  class: "p-input-icon-left",
  style: {"width":"22em"}
}
const _hoisted_54 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_55 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_56 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_57 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_58 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Lý do từ chối:", -1)
const _hoisted_61 = { class: "list_button" }
const _hoisted_62 = { class: "flex align-items-center gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Danh sách thiết bị từ chối ", -1)
const _hoisted_64 = { class: "p-fluid" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_66 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thống kê: ", -1)
const _hoisted_68 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_69 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_70 = {
  class: "p-input-icon-left",
  style: {"width":"22em"}
}
const _hoisted_71 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_72 = { style: {"font-weight":"bolder"} }
const _hoisted_73 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_74 = { id: "loading" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Đang xử lý xuất biên bản...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Badge, {
                  value: $setup.listThietBiTiepNhan.length,
                  severity: "contrast"
                }, null, 8, ["value"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Calendar, {
                    id: "date",
                    modelValue: $setup.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
                    selectionMode: "range",
                    dateFormat: "dd/mm/yy",
                    showButtonBar: true,
                    showIcon: true,
                    manualInput: false,
                    monthNavigator: true,
                    yearNavigator: true,
                    yearRange: "2000:2100",
                    onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadThietBiTiepNhan()))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Button, {
                    label: "Xử lý",
                    icon: "pi pi-spinner",
                    iconPos: "left",
                    onClick: $setup.exportTranferPage,
                    disabled: !$setup.validExportPage
                  }, null, 8, ["onClick", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Button, {
                    label: "Tải",
                    icon: "pi pi-download",
                    iconPos: "left",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downLoadFileExport($setup.link))),
                    disabled: !$setup.link
                  }, null, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_DataTable, {
                    loading: _ctx.isLoading,
                    value: $setup.listThietBiTiepNhan,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenThietBi','giaTriTiepNhan'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                    columnResizeMode: "fit | expand",
                    expandedRowGroups: $setup.expandedRowGroups,
                    "onUpdate:expandedRowGroups": _cache[6] || (_cache[6] = ($event: any) => (($setup.expandedRowGroups) = $event)),
                    expandableRowGroups: "",
                    rowGroupMode: "subheader",
                    groupRowsBy: "khoaPhongTruocChuyenGiao",
                    sortMode: "single",
                    sortField: "khoaPhongTruocChuyenGiao",
                    sortOrder: 1
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"6em"}
                        }),
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    groupheader: _withCtx((slotProps) => [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(slotProps.data.khoaPhongTruocChuyenGiao), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "STT",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenThietBi",
                        header: "Tên thiết bị",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianTiepNhan",
                        header: "Thời gian tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianCapNhat",
                        header: "Thời gian cập nhật",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriTiepNhan",
                        header: "Giá trị ban đầu",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriHienTai",
                        header: "Giá trị thời điểm tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianHaoMon",
                        header: "Thời gian hao mòn",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "tyLeHaoMon",
                        header: "Phần trăm hao mòn",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.tyLeHaoMon) + "% ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongTiepNhan",
                        header: "Khoa phòng tiếp nhận",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongHienTai",
                        header: "Khoa phòng hiện tại",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        header: "Khoa phòng chuyển",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString(data.khoaPhongChuyenGiao), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "banGiao",
                        header: "Xuất bàn giao",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Checkbox, {
                            modelValue: slotProps.data.banGiao,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.banGiao) = $event),
                            binary: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            type: "button",
                            label: "Xem",
                            icon: "pi pi-history",
                            onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Chuyển" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            severity: "warning",
                            type: "button",
                            label: "Chuyển",
                            icon: "pi pi-sync",
                            onClick: ($event: any) => ($setup.chuyenThietBi(slotProps.data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "filters", "expandedRowGroups"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Dialog, {
                  visible: $setup.chuyen,
                  "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (($setup.chuyen) = $event)),
                  style: { width: '40vw'},
                  breakpoints: { '1500px': '70vw', '1150px': '80vw' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Panel, { header: "Chuyển tài sản" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createVNode(_component_InputText, {
                              id: "khoaPhongNhan",
                              type: "text",
                              modelValue: $setup.tenThietBi,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.tenThietBi) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_component_Dropdown, {
                              id: "permission",
                              modelValue: $setup.thietBiChuyen.idKhoaPhongTiepNhan,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.thietBiChuyen.idKhoaPhongTiepNhan) = $event)),
                              options: $setup.khoaPhong,
                              optionLabel: "tenKhoaPhong",
                              optionValue: "id",
                              placeholder: "Vui lòng chọn khoa phòng nhận ..."
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          ($setup.valid)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: "Chuyển",
                                icon: "pi pi-sync",
                                iconPos: "left",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.thucHienChuyenThietBi())),
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                label: "Chuyển",
                                icon: "pi pi-sync",
                                iconPos: "left",
                                disabled: "disabled",
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Dialog, {
                  visible: $setup.xuat,
                  "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => (($setup.xuat) = $event)),
                  style: { width: '40vw'},
                  breakpoints: { '1500px': '70vw', '1150px': '80vw' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Panel, { header: "Tạo bên bản bàn giao tài sản" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createVNode(_component_InputText, {
                              id: "benbangiao1",
                              type: "text",
                              modelValue: $setup.bienBan1.benGiao1,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.bienBan1.benGiao1) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createVNode(_component_InputText, {
                              id: "chucvubangiao1",
                              type: "text",
                              modelValue: $setup.bienBan1.chucVuBenGiao1,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.bienBan1.chucVuBenGiao1) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_InputText, {
                              id: "benbangiao2",
                              type: "text",
                              modelValue: $setup.bienBan1.benGiao2,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.bienBan1.benGiao2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createVNode(_component_InputText, {
                              id: "chucvubangiao2",
                              type: "text",
                              modelValue: $setup.bienBan1.chucVuBenGiao2,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.bienBan1.chucVuBenGiao2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode(_component_InputText, {
                              id: "bennhan1",
                              type: "text",
                              modelValue: $setup.bienBan1.benNhan1,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.bienBan1.benNhan1) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createVNode(_component_InputText, {
                              id: "chucvunhan1",
                              type: "text",
                              modelValue: $setup.bienBan1.chucVuBenNhan1,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.bienBan1.chucVuBenNhan1) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createVNode(_component_InputText, {
                              id: "bennhan2",
                              type: "text",
                              modelValue: $setup.bienBan1.benNhan2,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.bienBan1.benNhan2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createVNode(_component_InputText, {
                              id: "chucvunhan2",
                              type: "text",
                              modelValue: $setup.bienBan1.chucVuBenNhan2,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.bienBan1.chucVuBenNhan2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode(_component_InputText, {
                              id: "Ghichu",
                              type: "text",
                              modelValue: $setup.bienBan1.ghiChu,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.bienBan1.ghiChu) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          ($setup.validBienBan)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: "Xuất",
                                icon: "pi pi-file-export",
                                iconPos: "left",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.exportFile())),
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                label: "Xuất",
                                icon: "pi pi-file-export",
                                iconPos: "left",
                                disabled: "disabled",
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_Badge, {
                  value: $setup.listThietBiChuyenGiao.length,
                  severity: "danger"
                }, null, 8, ["value"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_Calendar, {
                    id: "date",
                    modelValue: $setup.dateChuyenGiao,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.dateChuyenGiao) = $event)),
                    selectionMode: "range",
                    dateFormat: "dd/mm/yy",
                    showButtonBar: true,
                    showIcon: true,
                    manualInput: false,
                    monthNavigator: true,
                    yearNavigator: true,
                    yearRange: "2000:2100",
                    onDateSelect: _cache[23] || (_cache[23] = ($event: any) => ($setup.loadThietBiTiepNhan()))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_DataTable, {
                    loading: _ctx.isLoading2,
                    value: $setup.listThietBiChuyenGiao,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[26] || (_cache[26] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenThietBi','giaTriTiepNhan'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                    columnResizeMode: "fit | expand"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"6em"}
                        }),
                        _createElementVNode("span", _hoisted_53, [
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "STT",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenThietBi",
                        header: "Tên thiết bị",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianTiepNhan",
                        header: "Thời gian tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriTiepNhan",
                        header: "Giá trị ban đầu",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriHienTai",
                        header: "Giá trị thời điểm tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianHaoMon",
                        header: "Thời gian hao mòn",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "tyLeHaoMon",
                        header: "Phần trăm hao mòn",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.tyLeHaoMon) + "% ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongTiepNhan",
                        header: "Khoa phòng tiếp nhận",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongHienTai",
                        header: "Khoa phòng hiện tại",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongChuyenGiao",
                        header: "Khoa phòng chuyển giao",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, { header: "Bàn giao" }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_Button, {
                                type: "button",
                                severity: "warning",
                                label: "Nhận",
                                icon: "pi pi-check",
                                onClick: ($event: any) => ($setup.confirm(slotProps.data.id))
                              }, null, 8, ["onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_Button, {
                                type: "button",
                                severity: "danger",
                                label: "Từ chối",
                                icon: "pi pi-times",
                                onClick: ($event: any) => ($setup.tuChoiThietBi(slotProps.data.id))
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            type: "button",
                            label: "Lịch sử",
                            icon: "pi pi-check",
                            onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "filters"])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_Dialog, {
                  visible: $setup.tuChoi,
                  "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => (($setup.tuChoi) = $event)),
                  style: { width: '90vw'},
                  breakpoints: { '1500px': '70vw', '1150px': '80vw' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Panel, { header: "Từ chối tiếp nhận" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_InputText, {
                              id: "lyDo",
                              type: "text",
                              modelValue: $setup.thietBiReject.lyDo,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.thietBiReject.lyDo) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          ($setup.validTuChoi)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: "Xác nhận",
                                icon: "pi pi-sync",
                                iconPos: "left",
                                onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.thietBiRej())),
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                label: "Xác nhận",
                                icon: "pi pi-sync",
                                iconPos: "left",
                                disabled: "disabled",
                                style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                              }))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createVNode(_component_Badge, {
                  value: $setup.listThietBiTuChoi.length,
                  severity: "warning"
                }, null, 8, ["value"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode(_component_Calendar, {
                    id: "date",
                    modelValue: $setup.dateReject,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.dateReject) = $event)),
                    selectionMode: "range",
                    dateFormat: "dd/mm/yy",
                    showButtonBar: true,
                    showIcon: true,
                    manualInput: false,
                    monthNavigator: true,
                    yearNavigator: true,
                    yearRange: "2000:2100",
                    onDateSelect: _cache[31] || (_cache[31] = ($event: any) => ($setup.loadThietBiTuChoi()))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_DataTable, {
                    loading: _ctx.isLoading,
                    value: $setup.listThietBiTuChoi,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[34] || (_cache[34] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenThietBi','giaTriTiepNhan'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                    columnResizeMode: "fit | expand"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"6em"}
                        }),
                        _createElementVNode("span", _hoisted_70, [
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenThietBi",
                        header: "Tên thiết bị",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianTiepNhan",
                        header: "Thời gian tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriTiepNhan",
                        header: "Giá trị ban đầu",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giaTriHienTai",
                        header: "Giá trị thời điểm tiếp nhận",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianHaoMon",
                        header: "Thời gian hao mòn",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "tyLeHaoMon",
                        header: "Phần trăm hao mòn",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.tyLeHaoMon) + "% ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongTiepNhan",
                        header: "Khoa phòng tiếp nhận",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongHienTai",
                        header: "Khoa phòng hiện tại",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "khoaPhongChuyenGiao",
                        header: "Khoa phòng chuyển giao",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "lyDo",
                        header: "Lý do",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "thoiGianTuChoi",
                        header: "Thời gian từ chối",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTuChoi)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "nguoiTuChoi",
                        header: "Người từ chối",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            type: "button",
                            label: "Xem",
                            icon: "pi pi-history",
                            onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "filters"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createVNode(_component_Dialog, {
        visible: $setup.chiTietThietBi,
        "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => (($setup.chiTietThietBi) = $event)),
        style: { width: '90vw'},
        breakpoints: { '1500px': '70vw', '1150px': '80vw' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            loading: _ctx.isLoading,
            value: $setup.lichSu,
            paginator: true,
            stripedRows: "",
            rows: 10,
            rowsPerPageOptions: [10,25,50],
            rowHover: true,
            filters: $setup.filters,
            "onUpdate:filters": _cache[35] || (_cache[35] = ($event: any) => (($setup.filters) = $event)),
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['tenThietBi'],
            rowGroupMode: "rowspan",
            groupRowsBy: "tuChoi",
            sortOrder: 1,
            sortMode: "single",
            sortField: "tuChoi",
            currentPageReportTemplate: "Có tổng số {totalRecords} lần chuyển giao",
            columnResizeMode: "fit | expand"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Stt",
                headerStyle: "width:3rem"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "tuChoi",
                header: "Trạng thái",
                style: {"min-width":"100px"}
              }, {
                body: _withCtx(({data}) => [
                  _createElementVNode("span", _hoisted_72, _toDisplayString($setup.trangThai(data.tuChoi)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "tenThietBi",
                header: "Tên thiết bị"
              }),
              _createVNode(_component_Column, {
                field: "khoaPhongGiao",
                header: "Khoa phòng chuyển",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "thoiGianGiao",
                header: "Thời gian chuyển",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianGiao)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "khoaPhongNhan",
                header: "Khoa phòng nhận",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "thoiGianXacNhan",
                header: "Thời gian nhận",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianXacNhan)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "nguoiChuyen",
                header: "Người chuyển",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "nguoiNhan",
                header: "Người nhận",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "giaTriTiepNhan",
                header: "Giá trị ban đầu",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "giaTriHienTai",
                header: "Giá trị thời điểm tiếp nhận",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "lyDoTuChoi",
                header: "Nội dung",
                sortable: ""
              })
            ]),
            _: 1
          }, 8, ["loading", "value", "filters"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[37] || (_cache[37] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ]))
}